import { Component } from '@angular/core';

@Component({
  selector: 'app-driver-no-selected',
  templateUrl: './driver-no-selected.component.html',
  styleUrls: ['./driver-no-selected.component.css'],
})
export class DriverNoSelectedComponent {}
